import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';

/**
 * https://docs.sentry.io/platforms/javascript/angular/
 *
 * @export
 * @class SentryErrorHandler
 * @implements {ErrorHandler}
 */
@Injectable()
export class SentryErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    super.handleError(error);
    Sentry.captureException(error.originalError || error);
  }
}
